angular.module('picmonicng').factory('SpotlightService', [
  function () {
    return {
      focused: false,
      query: '',
    };
  },
]);
